// extracted by mini-css-extract-plugin
module.exports = {"batchDeleteButtons":"IncomeTaxDeclarationListPage__batchDeleteButtons--2m2FR","newDeclarationButton":"IncomeTaxDeclarationListPage__newDeclarationButton--13hWn"};